import React from 'react';
import { withI18n, withI18nProps } from '@lingui/react';
import { I18n } from '@lingui/core';

export const i18nHookContext = React.createContext<{ i18n: I18n }>({} as any);

export const I18nHookProvider = withI18n()<withI18nProps>(({ i18n, children }) => {
  return <i18nHookContext.Provider value={{ i18n }}>{children}</i18nHookContext.Provider>;
});
